import {Box} from "@mui/material";
import * as React from "react";
import {NotAllowedBlock} from "@components";

export default function productsFoundColumn() {
    return {
        name: 'productsFound', label: 'Products Found',
        options: {
            customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
                {!!value && value}
                {!value && <NotAllowedBlock />}
            </Box>
        }
    }
}